// extracted by mini-css-extract-plugin
module.exports = {"button":"_2BZQZF"};